import { createSelector } from 'reselect';

export const getProjectTags = createSelector(
  (state) => state.projects.scenes.details.scenes.projectTags.data.tags,
  (tags) => tags
);
